import { configureStore } from '@reduxjs/toolkit'
import checkoutReducer from './checkout/checkoutSlice';

export default configureStore({
  reducer: {
    checkout: checkoutReducer
  }
})